import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Explore from "./routes/Explore";
import MyProgress from "./routes/MyProgress";
import SchoolProgress from "./routes/SchoolProgress";
import Module from "./routes/Module";
export default store => ({
  path: "toddle-academy",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "toddle-academy" */ "./components"),
        import(
          /* webpackChunkName: "toddle-academy" */ "ToddleAcademy/modules/ToddleAcademyModules.js"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1;
        injectReducer(store, {
          key: reducer.NAME,
          reducer: reducer.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Explore(store),
    MyProgress(store),
    SchoolProgress(store),
    Module(store),
  ],
});
